import React from 'react';
import RenderClientSide from '../render/render-client-side';
import SphereViewer from '../sphere/sphere-viewer';

interface SphereFullscreenProps {
  url: string;
  webp?: string;
}

const SphereFullscreen = ({ url, webp }: SphereFullscreenProps) => {
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <RenderClientSide>
        <SphereViewer
          id={url.split('/')[5]}
          src={webp || url}
          autoLoad={true}
          fullscreen={false}
          modifiers=""
        />
      </RenderClientSide>
    </div>
  );
};

export default SphereFullscreen;
